import { Helper } from "../../utils/Helper";
import { IEngineCallbacks } from "./IEngine";
import {  gsap } from "gsap";

export abstract class BasicEngine {

    private _callbacks:IEngineCallbacks;
    protected _animateContainer:PIXI.Container;

    private _activeTimeline:gsap.core.Timeline | undefined;
    private _nextTimeline:gsap.core.Timeline | undefined;

    protected _stepDistance:number = 0;
    protected _reverse:boolean = false;

    constructor(callbacks:IEngineCallbacks, target:PIXI.Container) {
        this._callbacks = callbacks;
        this._animateContainer = target;
    }

    public set stepDistance(value:number){
        this._stepDistance = value;
    }

    public get stepDistance():number {
        const distance:number = this._stepDistance;
        return (this.reverse ? -1 : 1) *  Math.abs(distance);
    }

    protected get yPos():number {
        return this._animateContainer.y;
    }

    protected set yPos(value:number) {
        this._animateContainer.y = value;
    }

    protected get duration():number{ return this._activeTimeline ? this._activeTimeline.duration() : 0; }

    public set reverse(value:boolean) {
        this._reverse = value;
    }

    public get reverse():boolean {
        return this._reverse;
    }

    protected get callbacks():IEngineCallbacks{
        return this._callbacks;
    }
    
    public get activeTimeline():gsap.core.Timeline | undefined{
        return this._activeTimeline;
    }

    public set activeTimeline(value:gsap.core.Timeline | undefined){
        this._activeTimeline = value;
    }

    public get nextTimeline():gsap.core.Timeline | undefined{
        return this._nextTimeline;
    }

    public set nextTimeline(value:gsap.core.Timeline | undefined){
        this._nextTimeline = value;
    }

    public get isActive():boolean {
        return this.activeTimeline != undefined && this.activeTimeline.isActive();
    }

    public get timeLeft(): number {
        if (!this.isActive) return 0;
        return this.activeTimeline!.duration() - this.activeTimeline!.time();
    }

    public get nextPlayDuration(): number {
        if (!this.nextTimeline) return 0;
        return this.nextTimeline!.totalDuration();
    }

    public activateNextAnimation(startYPos?:number):void{
        if(startYPos != undefined) this.yPos = startYPos;
        this._activeTimeline = Helper.setTimeline(this._activeTimeline);

        this._activeTimeline = this._nextTimeline;
        this._nextTimeline = undefined;

        if(!this._activeTimeline) debugger;
        this._activeTimeline!.play();
    }

    public abstract Start():void;

    public Step?():void;

    public abstract Stop():void;

    public Idle?():void;

    public Nudge?():void;
}